module.exports = __webpack_public_path__ + "static/img/shoesman.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/shoesman.jpg
// module id = 0axB
// module chunks = 1